import settings from '@constants/settings';

const imageLink = (id: string): string => {
    return `${settings.serverUrl}/image/${id}`
}

export default imageLink;